import Image from './image';

// generated by https://png-pixel.com/
const placeholderImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mPc/x8AAoMBwP8UKJsAAAAASUVORK5CYII=';

const CustomFeedLogo = ({feedName, feedLogo}) => {
    const logoUrl = feedLogo ? `https://img.scored.co/feed/${feedName.toLowerCase()}-icon-32x32.png?v=${feedLogo}` : placeholderImage;
    return (
        <Image
            src={logoUrl || placeholderImage}
            alt={""}
            fallbackSrc={placeholderImage}
        />
    );
};

export default CustomFeedLogo;
